import { map, isEmpty } from "lodash";

const buildNode = ({
  id,
  name,
  active,
  toggled,
  disabled,
  children = [],
  ...rest
}) => ({
  id,
  name,
  active,
  toggled,
  disabled,
  children,
  ...rest,
});

const getChildren = ({
  nodeId,
  tags,
  activeTagId,
  childrenLoaded,
  toggledNodes,
}) => {
  if (!nodeId) {
    return [];
  }

  const children = [];

  // Add tag values
  const childrenData = map(tags[nodeId]?.tags || [], (tag) => {
    // For each tag value, recursively build its children

    const childrenLoadedData =
      (childrenLoaded[tag.id] &&
        getChildren({
          nodeId: tag.id,
          tags,
          activeTagId,
          childrenLoaded,
          toggledNodes,
        })) ||
      [];

    const childNode = buildNode({
      id: tag.id,
      name: tag.displayValue,
      active: tag.id === activeTagId,
      toggled: toggledNodes[tag.id] || false,
      disabled: childrenLoaded[tag.id] && childrenLoadedData.length === 0,
      children: childrenLoadedData,
    });

    return childNode;
  });

  children.push(...childrenData);
  return childrenLoaded[nodeId] && isEmpty(childrenData) ? [] : children;
};

const buildTagTypeTree = ({
  nodeId,
  tags,
  activeTagId,
  node,
  childrenLoaded,
  toggledNodes,
}) => {
  if (!nodeId) {
    return [];
  }

  const nodeName = tags[nodeId]?.name || node?.name || nodeId;

  const children =
    (childrenLoaded[nodeId] &&
      getChildren({
        nodeId,
        tags,
        activeTagId,
        childrenLoaded,
        toggledNodes,
      })) ||
    [];

  // Build tree node with essential properties
  const treeData = buildNode({
    id: nodeId,
    name: nodeName,
    active: activeTagId === nodeId,
    toggled: toggledNodes[nodeId],
    disabled: childrenLoaded[nodeId] && children.length === 0,
    children: childrenLoaded[nodeId] ? children : [],
  });

  return [treeData];
};

export default buildTagTypeTree;
